import { render, staticRenderFns } from "./Edit-Alumni.vue?vue&type=template&id=2fa61bef&scoped=true"
import script from "./Edit-Alumni.vue?vue&type=script&lang=js"
export * from "./Edit-Alumni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa61bef",
  null
  
)

export default component.exports